/**
 * Connect the skip link to a stable main-content target.
 *
 * Most templates already provide a real main landmark, so the script should
 * point the skip link there instead of creating duplicate heading IDs. When a
 * legacy template does not expose a main landmark, we fall back to the first H1
 * and only add an ID when that heading does not already have one. This keeps
 * author-managed anchor links intact while preserving the keyboard shortcut.
 *
 * @since 1.0.0
 */
export function initH1JumpIds() {
	const skipLink = document.querySelector( '.skip-to-main-content' );

	if ( ! skipLink ) {
		return;
	}

	const target = document.getElementById( 'main' ) ||
		document.querySelector( 'main, [role="main"]' ) ||
		document.querySelector( 'h1' );

	if ( ! target ) {
		return;
	}

	if ( target.id ) {
		skipLink.setAttribute( 'href', `#${ target.id }` );
		return;
	}

	target.id = 'skip';
	skipLink.setAttribute( 'href', '#skip' );
}
